import React from 'react';
import type { Theme } from '@mui/material';
import type { ITheme } from '../../../../../component_library/styles/theme';
import type { IDialogData } from '../../../../../dotcms/dotcms-models/dotcms-dialog';
import Dialog from '../../../../../component_library/components/Dialog/Dialog';
import HtmlBox from '../../../../../component_library/components/HtmlBox/HtmlBox';
import { DataElementId } from '../../../../../constants/data-element-tracking-ids';

interface IProps {
  theme: ITheme;
  muiTheme: Theme;
  dialog: IDialogData;
  dialogOpen: boolean;
  handleDialogClose: () => void;
  handleDialogUndo: undefined | (() => void);
  undoLoading: boolean;
}

export const WithdrawalStayEnrolledDialog: React.FC<IProps> = ({
  theme,
  muiTheme,
  dialog,
  dialogOpen,
  handleDialogClose,
  handleDialogUndo,
  undoLoading,
}) => (
  <Dialog
    id="withdrawal-stay-enrolled-dialog"
    dataElementId={DataElementId.ACCOUNT_PAGE_WITHDRAWAL_UNDO_DIALOG}
    open={dialogOpen}
    theme={theme}
    muiTheme={muiTheme}
    headlineContent={<HtmlBox html={dialog.headline} />}
    primaryButton={
      dialog.primaryButton
        ? {
          content: dialog.primaryButton.text,
          onClick: handleDialogUndo,
          dataElementId: DataElementId.ACCOUNT_PAGE_WITHDRAWAL_UNDO_DIALOG,
          loading: undoLoading,
        }
        : undefined
    }
    secondaryButton={
      dialog.secondaryButton && !undoLoading
        ? {
          content: dialog.secondaryButton.text,
          onClick: handleDialogClose,
          dataElementId:
              DataElementId.ACCOUNT_PAGE_WITHDRAWAL_UNDO_DIALOG_KEEP_WITHDRAWAL,
        }
        : undefined
    }
    onDialogClose={undoLoading ? undefined : handleDialogClose}
  >
    <HtmlBox html={dialog.content} />
  </Dialog>
);
